import { Controllers, ProblemResult } from "@infoland/iprova-api";

interface IUASFormData {
    Action: "Set" | "Get" | "Remove";
    Key: string;
    Value?: string;
}

//private
function submit(data: IUASFormData): Promise<string | void> {
    const headers = { "Content-Type": "application/x-www-form-urlencoded", Accept: "text/plain" };
    return Controllers.GenericController.postAsync<IUASFormData, string | void>(
        `../Management/Webservices/UserApplicationState.ashx`,
        data,
        false,
        headers
    );
}

/**
 * Sets a value the user application state
 * @param key key of the value
 * @param value The value
 * @returns
 */
export function set(key: string, value: string): Promise<void> {
    return submit({
        Action: "Set",
        Key: key,
        Value: value
    }) as Promise<void>;
}

/**
 * Gets a value from the user application state
 * @param key key of the value
 * @returns the value
 */
export async function get(key: string): Promise<string> {
    return submit({
        Action: "Get",
        Key: key
    }) as Promise<string>;
}

/**
 * Remove a value from the user application state
 * @param key key of the value
 * @returns
 */
export async function remove(key: string): Promise<void> {
    return submit({
        Action: "Remove",
        Key: key
    }) as Promise<void>;
}
